import { connect } from "react-redux";
import { EditFeatureDispatchProps, EditFeatureStateProps, EditFeatureToolbar } from "./component/EditFeatureToolbar";
import { finishVisualGeometryEditAction } from "./action/finishVisualGeometryEditAction";
import { embeddedInPortalSelector } from "../url/selector/urlParamsSelector";
import { registerPlugin } from "../common/mapstore/registerPlugin";
import { RootState } from "../rootState";
import {
    editFeatureReducer,
    editGeometryEpic,
    finishGeometryEpic,
    finishVisualGeometryEpic,
    geometryChangedEpic,
    insertFeatureEpic,
    isEditModeEnabled,
    setGeometryStyleEpic,
    viewGeometryEpic,
    changeEditModeAction,
    densifyGeometryAction,
    EditFeatureOptions,
    finishGeometryEditAction,
} from "./redux";
import { EditAction } from "./redux/types";
import { FeatureCollection } from "../core/geo/types";
import { selectFeatureForEditing } from "../common/mapstore/action/draw";
import { isArcModeEnabledSelector } from "../common/selector/configurationSelector";
import { Dispatch } from "redux";

const mapStateToProps = (state: RootState): EditFeatureStateProps => {
    return {
        editEnabled: isEditModeEnabled(state) && embeddedInPortalSelector(state),
        editFeature: state.editFeature!,
        editAction: state.editFeature?.options.action ?? EditAction.NONE,
        editPaused: state.editFeature?.options.editPaused ?? false,
        arcModeEnabled: isArcModeEnabledSelector(state),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<any>): EditFeatureDispatchProps => {
    return {
        finish: () => dispatch(finishVisualGeometryEditAction()),
        changeEditActionMode: (value) => dispatch(changeEditModeAction(value)),
        densifyGeometry: () => dispatch(densifyGeometryAction()),
        selectFeatureForEditing: (features: FeatureCollection, options: EditFeatureOptions) =>
            dispatch(selectFeatureForEditing(features, options)),
        cancelEditing: () => dispatch(finishGeometryEditAction()),
    };
};

export const ConnectedEditFeature = connect(mapStateToProps, mapDispatchToProps)(EditFeatureToolbar);

export const EditFeaturePlugin = {
    name: "EditFeaturePlugin",
    config: {
        component: ConnectedEditFeature,
        reducers: {
            editFeature: editFeatureReducer,
        },
        epics: {
            editGeometryEpic,
            setGeometryStyleEpic,
            finishGeometryEpic,
            geometryChangedEpic,
            viewGeometryEpic,
            insertFeatureEpic,
            finishVisualGeometryEpic,
        },
    },
};
export const register = () => registerPlugin(EditFeaturePlugin);
